// @flow

export const formatCentsAsDollars = (amountInCents: number) => {
  const amountInCentsAbsoluteValue = Math.abs(amountInCents);
  const amountInCentsString = amountInCentsAbsoluteValue.toString();
  const dollarAmount = amountInCentsString.substring(0, amountInCentsString.length - 2) || '0';
  const centsAmount =
    amountInCentsAbsoluteValue < 10
      ? `0${amountInCentsString}`
      : amountInCentsString.substring(amountInCentsString.length - 2);
  return amountInCents < 0 ? `-${dollarAmount}.${centsAmount}` : `${dollarAmount}.${centsAmount}`;
};

export const formatDollarsForDisplay = (amountInDollars: string) => {
  if (amountInDollars === '') {
    return '';
  }
  const numberFormatter = new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
  return numberFormatter.format(Number(amountInDollars));
};

export const parseDollarsToCents = (inputAmount: string): number => {
  if (inputAmount === '' || Number.isNaN(Number(inputAmount))) {
    return NaN;
  }
  const isNegativeInputAmount = Number(inputAmount) < 0;
  const inputAmountAbsoluteValue = inputAmount.replace('-', '');
  const amountSegments = inputAmountAbsoluteValue.split('.');
  let totalAmountInCents = amountSegments[0] ? Number(amountSegments[0]) * 100 : 0;

  if (amountSegments.length > 1) {
    const centsAmount = Number(`${amountSegments[1]}0`.substring(0, 2));
    totalAmountInCents += centsAmount;
  }
  return isNegativeInputAmount ? totalAmountInCents * -1 : totalAmountInCents;
};
